import { amountDefaultAccelerators } from 'utils/amount';

export const parseNumberWithAccelerator = (value: unknown): number | undefined => {
  if (typeof value !== 'string') {
    return undefined;
  }

  const trimmedValue = value.trim();
  if (trimmedValue === '') {
    return undefined;
  }

  const acceleratorKey = trimmedValue.match(/[a-zA-Z]+$/)?.[0];
  const accelerator = acceleratorKey
    ? amountDefaultAccelerators.find(a => a.key === acceleratorKey.toLowerCase())
    : undefined;

  if (accelerator === undefined) {
    const parsedValue = Number(trimmedValue);
    return Number.isNaN(parsedValue) ? undefined : parsedValue;
  }

  const baseValue = Number(trimmedValue.slice(0, -acceleratorKey!.length));
  return Number.isNaN(baseValue) ? undefined : accelerator.transform(baseValue);
};
